import { getParksMap } from './parks/getters';
// Constants
export const EVENTS = {
    VISITOR_INTERACTION: 'visitor interaction',
};
export const INTERACTION_NAMES = {
    ACCORDION_CLICK: 'accordion click',
    VIDEO_CLICK: 'video click',
};
const PARK_NAME_MAP = {
    OR: 'the orchards',
};
// Helpers
export const getVideoClickDataLayer = (linkAction, linkUrl, linkTitle) => ({
    event: EVENTS.VISITOR_INTERACTION,
    interactionName: INTERACTION_NAMES.VIDEO_CLICK,
    linkAction,
    linkUrl: linkUrl.startsWith('//') ? `https:${linkUrl}` : linkUrl,
    linkTitle: linkTitle ? linkTitle.toLowerCase() : null,
});
const prepareStringArrays = (items) => Array.from(new Set(items.filter(Boolean)))
    .sort()
    .join('|');
export const getParksAnalytics = (parkCodes) => {
    const parkMap = getParksMap();
    const parks = parkCodes
        .map((parkCode) => parkMap.get(parkCode))
        .filter((park) => park !== undefined);
    const getParkAttribute = (attribute) => {
        return prepareStringArrays(parks.map(attribute));
    };
    return {
        parkCode: getParkAttribute((park) => park.code).toUpperCase(),
        parkName: getParkAttribute((park) => PARK_NAME_MAP[park.code] || park.name).toLowerCase(),
        parkRegion: getParkAttribute((park) => park.region.name).toLowerCase(),
    };
};
export default {
    getVideoClickDataLayer,
};
